export const environment = {
  production: false,
  'API_URL': 'https://api.csipm.online',
  'USE_NGROK': 'false',
  'MAXIMUM_EMULATION_INTERVAL_SEC': '10',
  'MINIMUM_EMULATION_INTERVAL_SEC': '1',
  'EMULATION_DAYS': '5'
};
